<template>
  <div class="questionnaire-live">
    <vh-dialog
      :visible.sync="dialogVisible"
      width="720px"
      custom-class="questionnaire-dialog"
      lock-scroll
      :modal-append-to-body="false"
      :close-on-click-modal="false"
    >
      <!-- title -->
      <header slot="title" class="dialog-title">
        <i
          v-if="!showQuestionnaireTable"
          class="vh-iconfont vh-line-arrow-left back-btn"
          style="cursor: pointer"
          @click="initPage"
        />
        {{ $t('host.k_585001') }}
        <span class="headBtnGroup" v-if="showTip">
          <vh-button type="text" @click="openSet" class="name_set_button">
            {{ $t('host.k_585002') }}
          </vh-button>
          <i class="vh-iconfont vh-line-question" @click="showPreview"></i>
        </span>
        <vh-tooltip v-else :content="$t('host.k_585003')" placement="right">
          <i class="vh-iconfont vh-line-question"></i>
        </vh-tooltip>
      </header>
      <section class="question__content">
        <div class="vhall-question__content" v-show="showQuestionnaireTable">
          <div class="show-no-list" v-if="noQuestionnaire">
            <div class="text-center show-no-msg">
              <span class="no-img"><img src="./images/no-create@2x.png" alt="" /></span>
              <p class="no-msg">{{ $t('host.k_585004') }}</p>
              <p class="list-create" @click="createQuestion('')">{{ $t('host.k_585005') }}</p>
            </div>
          </div>
          <template v-else>
            <div class="vhall-question__content-search">
              <vh-button
                class="create"
                size="medium"
                type="primary"
                round
                @click="createQuestion(null)"
              >
                {{ $t('host.k_585005') }}
              </vh-button>
              <vh-input
                v-model="keyword"
                :placeholder="$t('host.k_585006')"
                style="width: 220px; float: right"
                @keyup.enter.native="queryQuestionnaireList(true)"
                @clear="clearKeyword"
                clearable
              >
                <i
                  slot="prefix"
                  class="vh-icon-search vh-input__icon"
                  style="cursor: pointer; line-height: 36px"
                  @click="clearKeyword"
                ></i>
              </vh-input>
            </div>
            <div class="popbody">
              <ul class="vhall-question__content-list">
                <!-- 标题头 -->
                <li class="vhall-question__content-list__title">
                  <span class="vhall-question__content-list__colmun-title fontColor">
                    {{ $t('host.k_585007') }}
                  </span>
                  <span class="vhall-question__content-list__colmun-time fontColor">
                    {{ $t('host.k_585008') }}
                  </span>
                  <span class="vhall-question__content-list__colmun-source fontColor">
                    {{ $t('host.k_585009') }}
                  </span>
                  <span class="vhall-question__content-list__colmun-action fontColor">
                    {{ $t('host.k_585010') }}
                  </span>
                </li>
                <div
                  v-if="questionnaireList.length"
                  class="data-list"
                  v-infinite-scroll="moreLoadData"
                >
                  <li v-for="(item, idx) in questionnaireList" :key="idx">
                    <span class="vhall-question__content-list__colmun-title">{{ item.title }}</span>
                    <span class="vhall-question__content-list__colmun-time">
                      {{ item.topic_num }}
                    </span>
                    <span class="vhall-question__content-list__colmun-source">
                      {{ item.updated_at }}
                    </span>
                    <span class="vhall-question__content-list__colmun-action">
                      <span class="item" @click="publish(item)">{{ $t('host.k_585011') }}</span>
                      <span class="item" @click="prevQuestion(item.question_id)">
                        {{ $t('host.k_585012') }}
                      </span>
                      <span class="item" @click="editQuestion(item)">
                        {{ $t('host.k_585013') }}
                      </span>
                      <span @click.prevent.stop class="item">
                        <vh-dropdown
                          @command="handleCommand"
                          @visible-change="dropDownVisibleChange(item)"
                        >
                          <span class="colorItem">{{ $t('host.k_585014') }}</span>
                          <vh-dropdown-menu
                            style="width: 140px; text-align: center"
                            slot="dropdown"
                            class="questionnarie"
                          >
                            <vh-dropdown-item
                              command="data"
                              v-if="
                                item.publish == 1 &&
                                !isEmbed &&
                                role == 1 &&
                                !hideItem &&
                                !$route.query.live_token
                              "
                            >
                              {{ $t('host.k_585015') }}
                            </vh-dropdown-item>
                            <vh-dropdown-item command="copy">
                              {{ $t('host.k_585016') }}
                            </vh-dropdown-item>
                            <vh-dropdown-item command="del">
                              {{ $t('host.k_585017') }}
                            </vh-dropdown-item>
                          </vh-dropdown-menu>
                        </vh-dropdown>
                      </span>
                    </span>
                  </li>
                </div>
                <div v-else-if="!loading" class="show-no-msg">
                  <span class="no-img">
                    <img src="./images/no-search@2x.png" alt="" />
                  </span>
                  <p class="no-msg">{{ $t('host.k_585018') }}</p>
                </div>
              </ul>
            </div>
          </template>
        </div>
        <section
          class="qn-server-warp"
          :class="{
            preview: prevQuestionnaireId
          }"
          v-show="!showQuestionnaireTable"
        >
          <div id="qn-server-box" class="question-box-dialog"></div>
          <vh-button
            class="publish-btn"
            round
            v-if="prevQuestionnaireId"
            @click="
              publish({
                question_id: prevQuestionnaireId,
                fromPrev: true
              })
            "
          >
            {{ $t('host.k_585019') }}
          </vh-button>
        </section>
      </section>
    </vh-dialog>

    <vh-dialog
      :visible.sync="saveDialogVisible"
      custom-class="save-dialog"
      width="400px"
      :title="$t('host.k_585020')"
    >
      <div class="async__ctx">
        <p>{{ $t('host.k_585021') }}</p>
        <vh-checkbox v-model="shareQuestionnaire">{{ $t('host.k_585022') }}</vh-checkbox>
      </div>
      <div class="async__footer" slot="footer">
        <vh-button type="primary" :disabled="!saveDialogVisible" @click="saveQuestionnaire" round>
          {{ $t('host.k_585023') }}
        </vh-button>
        <vh-button @click="handleCancel" round>{{ $t('host.k_585024') }}</vh-button>
      </div>
    </vh-dialog>

    <!-- 别名设置弹框 -->
    <vh-dialog
      :visible.sync="dialogNameSet"
      custom-class="save-dialog"
      width="400px"
      :title="$t('host.k_585020')"
    >
      <div>
        <div class="async__ctx">
          <vh-input v-model="alias" :placeholder="$t('host.k_585025')" maxlength="8">
            <div slot="suffix" style="font-size: 10px; color: #999; margin-top: 13px">
              <span
                :style="{
                  color: alias.length == 8 ? '#fb3a32' : alias.length > 0 ? '#3562fa' : '#999'
                }"
              >
                {{ alias.length }}
              </span>
              <span>/</span>
              <span>8</span>
            </div>
          </vh-input>
          <p class="setname_tip">{{ $t('host.k_585026') }}</p>
        </div>
        <div class="setname_button">
          <vh-button type="primary" size="medium" @click="saveAlias" round>
            {{ $t('host.k_585027') }}
          </vh-button>
          <vh-button
            plain
            size="medium"
            @click="closeDialogNameSet"
            round
            class="hover_button_cancel"
          >
            {{ $t('host.k_585028') }}
          </vh-button>
        </div>
      </div>
    </vh-dialog>

    <!-- 图列展示弹框 -->
    <vh-dialog
      :visible.sync="dialogPreview"
      custom-class="preview_dialog"
      width="740px"
      :show-close="true"
    >
      <div class="img_base">
        <img src="./images/Q_preview.png" alt="" class="img_size" />
      </div>
    </vh-dialog>
  </div>
</template>
<script>
  import { useQuestionnaireServer, useChatServer } from 'middle-domain';
  import { cl_openUrl } from '@/app-shared/client/client-methods.js';
  export default {
    name: 'VmpQuestionnaire',
    provide() {
      return {
        questionnaireServer: this.questionnaireServer
      };
    },
    data() {
      return {
        dialogVisible: false, // 顶层弹窗是否显示
        showQuestionnaireTable: true, // 显示问卷列表
        firstLoad: false, // 完成首次列表数据加载(防止首次加载闪动画面)
        loading: false, // 列表请求加载中
        questionnaireList: [], // 问卷列表
        selectedQuestionnarie: null, // 为下拉框交互中转变量
        queryParams: {
          // 问卷列表搜索参数
          limit: 10,
          pos: 0,
          pageNum: 1,
          keyword: ''
        },
        keyword: '', //input的value;
        questionnaireCreateInfo: null, // 已创建弹窗的中转
        saveDialogVisible: false, // 同步问卷弹窗
        shareQuestionnaire: true, // 同步到管理
        prevQuestionnaireId: false, // 显示预览状态的相关UI
        saving: false, //保存中的状态
        totalPages: 0, // 总页数
        dialogNameSet: false,
        dialogPreview: false,
        alias: this.$t('host.k_585001'),
        showTip: false
      };
    },
    computed: {
      // 显示未创建过问卷面板
      noQuestionnaire() {
        return (
          this.firstLoad &&
          !this.questionnaireList.length &&
          this.queryParams.keyword === '' &&
          !this.loading
        );
      },
      // 是否为嵌入页
      isEmbed() {
        return this.$domainStore?.state?.roomBaseServer?.embedObj?.embed;
      },
      // 当前角色
      role() {
        return this.$domainStore?.state?.roomBaseServer?.watchInitData?.join_info.role_name;
      },
      // 权限配置
      configList() {
        return this.$domainStore.state.roomBaseServer.configList;
      },
      // 隐藏部分文案及选项(安利定制)
      hideItem() {
        return (
          this.configList['hidden_asset_library'] ||
          (this.configList['initiate_embed_function_close'] &&
            (this.$route.query.liveT ||
              this.$route.query.live_token ||
              this.$route.query.assistant_token))
        );
      }
    },
    beforeCreate() {
      this.questionnaireServer = useQuestionnaireServer({
        uploadUrl: process.env.VUE_APP_BASE_URL,
        creatSelector: '#qs-create-box',
        mode: 'live'
      });
    },
    created() {
      this.initEvent();
      console.log(this.configList, this.$route.query.liveT, 'configList');
    },
    methods: {
      async open() {
        // 初始化文件PaaS SDK, 使用了单例模式，多次执行不能影响
        await this.questionnaireServer.loadAndInit({
          mode: 'live',
          locale: this.$i18n.locale === 'en' ? this.$i18n.locale : 'zh'
        });

        this.initPage();
        this.dialogVisible = true;
      },
      close() {
        this.dialogVisible = false;
      },
      handleQu(flag) {
        flag ? this.open() : this.close();
      },
      initPage() {
        this.firstLoad = false;
        this.showTip = false;
        this.showQuestionnaireTable = true;
        this.prevQuestionnaireId = null;
        this.queryQuestionnaireList(true);
      },
      initEvent() {
        this.questionnaireServer.$on(
          this.questionnaireServer.EVENT_TYPE.QUESTIONNAIRE_CREATE,
          data => {
            this.questionnaireCreateInfo = data;
            this.setReportData(data);
            window.vhallReportForProduct &&
              window.vhallReportForProduct.report(110062, {
                report_extra: { id: data.id }
              });
            if (!this.hideItem) {
              this.saveDialogVisible = true;
              this.shareQuestionnaire = true;
            } else {
              this.shareQuestionnaire = false;
              this.saveQuestionnaire();
            }
            this.saving = false;
          }
        );
        this.questionnaireServer.$on(
          this.questionnaireServer.EVENT_TYPE.QUESTIONNAIRE_UPDATE,
          (res, data) => {
            this.setReportData(data);
            if (res.code === 200) {
              this.initPage();
            }
          }
        );
        this.questionnaireServer.$on(
          this.questionnaireServer.EVENT_TYPE.QUESTIONNAIRE_PUSH,
          async msg => {
            // 初始化文件PaaS SDK, 使用了单例模式，多次执行不能影响
            await this.questionnaireServer.loadAndInit({
              mode: 'live',
              locale: this.$i18n.locale === 'en' ? this.$i18n.locale : 'zh'
            });
            const join_info = this.$domainStore?.state?.roomBaseServer?.watchInitData?.join_info;
            let text = this.$getRoleName(msg.room_role);
            if (msg.room_role != 1) {
              text = `${text}${msg.nick_name}`;
            }
            useChatServer().addChatToList({
              nickname: this.$t('host.k_585001'),
              avatar: '//cnstatic01.e.vhall.com/static/images/watch/system.png',
              content: {
                text_content: this.$t('host.k_585029', [text]),
                questionnaire_id: msg.questionnaire_id,
                title: msg.title
              },
              roleName: join_info.role_name,
              type: msg.type
            });
          }
        );
      },
      /**
       * @description 条件搜索列表
       */
      queryQuestionnaireList(refresh = false) {
        if (refresh) {
          this.queryParams = {
            limit: 10,
            pos: 0,
            pageNum: 1,
            keyword: ''
          };
          this.questionnaireList = [];
        }
        this.loading = true;
        this.queryParams.keyword = this.keyword;
        this.questionnaireServer
          .queryQuestionnaireList({
            keyword: this.queryParams.keyword,
            limit: this.queryParams.limit,
            pos: this.queryParams.pos
          })
          .then(res => {
            const dataList = res.data.list || [];
            this.questionnaireList = this.questionnaireList.concat(dataList);
            this.firstLoad = true;
            this.totalPages = Math.ceil(res.data.total / this.queryParams.limit);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      /**
       * @description 清空关键字搜索
       */
      clearKeyword() {
        this.queryQuestionnaireList(true);
      },
      /**
       * @description 创建问卷
       */
      createQuestion() {
        const selector = '#qn-server-box';
        this.showQuestionnaireTable = false;
        this.prevQuestionnaireId = null;
        this.questionnaireServer.renderCreatQuestionnaire(selector);
        this.showTip = true;
        // 若当前是创建出发，alias别名设置为 ‘’
        this.alias = this.$t('host.k_585001');
      },
      /**
       * @description 编辑问卷
       */
      editQuestion(row) {
        console.log(row, '131231');
        const selector = '#qn-server-box';
        this.showQuestionnaireTable = false;
        this.showTip = true;
        this.prevQuestionnaireId = null;
        this.alias = row.alias || this.$t('host.k_585001');
        this.questionnaireServer.renderCreatQuestionnaire(selector, row.question_id);
      },
      setReportData(data) {
        const { id, title, description, detail, imgUrl } = data;
        const playback_filling = JSON.parse(data.extension).playback_filling;
        if (title !== this.$t('host.k_585030')) {
          window.vhallReportForProduct &&
            window.vhallReportForProduct.report(110068, {
              report_extra: { id: id }
            });
        }
        if (description !== this.$t('host.k_585031')) {
          window.vhallReportForProduct &&
            window.vhallReportForProduct.report(110069, {
              report_extra: { id: id }
            });
        }
        if (imgUrl) {
          window.vhallReportForProduct &&
            window.vhallReportForProduct.report(110070, {
              report_extra: { id: id }
            });
        }
        window.vhallReportForProduct &&
          window.vhallReportForProduct.report(playback_filling == 1 ? 110071 : 110072, {
            report_extra: { id: id }
          });
        detail.map(item => {
          if (item.style === 'name') {
            window.vhallReportForProduct &&
              window.vhallReportForProduct.report(110073, {
                report_extra: { id: id }
              });
            window.vhallReportForProduct &&
              window.vhallReportForProduct.report(item.required === 'Y' ? 110074 : 110075, {
                report_extra: { id: id }
              });
          }
          if (item.style === 'sex') {
            window.vhallReportForProduct &&
              window.vhallReportForProduct.report(110076, {
                report_extra: { id: id }
              });
            window.vhallReportForProduct &&
              window.vhallReportForProduct.report(item.required === 'Y' ? 110077 : 110078, {
                report_extra: { id: id }
              });
            let num = 0;
            item.detail.list.forEach(items => {
              if (items.isAdd) {
                num++;
              }
            });
            if (num) {
              window.vhallReportForProduct &&
                window.vhallReportForProduct.report(110079, {
                  report_extra: { id: id, other: num }
                });
            }
          }
          if (item.style === 'email') {
            window.vhallReportForProduct &&
              window.vhallReportForProduct.report(110080, {
                report_extra: { id: id }
              });
            window.vhallReportForProduct &&
              window.vhallReportForProduct.report(item.required === 'Y' ? 110081 : 110082, {
                report_extra: { id: id }
              });
          }
          if (item.style === 'area') {
            window.vhallReportForProduct &&
              window.vhallReportForProduct.report(110083, {
                report_extra: { id: id }
              });
            window.vhallReportForProduct &&
              window.vhallReportForProduct.report(item.required === 'Y' ? 110084 : 110085, {
                report_extra: { id: id }
              });
          }
          if (item.style === 'birthday') {
            window.vhallReportForProduct &&
              window.vhallReportForProduct.report(110092, {
                report_extra: { id: id }
              });
            window.vhallReportForProduct &&
              window.vhallReportForProduct.report(item.required === 'Y' ? 110093 : 110094, {
                report_extra: { id: id }
              });
          }
          if (item.style === 'company') {
            window.vhallReportForProduct &&
              window.vhallReportForProduct.report(110086, {
                report_extra: { id: id }
              });
            window.vhallReportForProduct &&
              window.vhallReportForProduct.report(item.required === 'Y' ? 110087 : 110088, {
                report_extra: { id: id }
              });
          }
          if (item.style === 'position') {
            window.vhallReportForProduct &&
              window.vhallReportForProduct.report(110089, {
                report_extra: { id: id }
              });
            window.vhallReportForProduct &&
              window.vhallReportForProduct.report(item.required === 'Y' ? 110090 : 110091, {
                report_extra: { id: id }
              });
          }
          if (item.style === 'industry') {
            window.vhallReportForProduct &&
              window.vhallReportForProduct.report(110095, {
                report_extra: { id: id }
              });
            window.vhallReportForProduct &&
              window.vhallReportForProduct.report(item.required === 'Y' ? 110096 : 110097, {
                report_extra: { id: id }
              });
          }
          if (item.style === 'education') {
            window.vhallReportForProduct &&
              window.vhallReportForProduct.report(110098, {
                report_extra: { id: id }
              });
            window.vhallReportForProduct &&
              window.vhallReportForProduct.report(item.required === 'Y' ? 110099 : 110100, {
                report_extra: { id: id }
              });
          }
          // 单选题
          if (item.type === 'radio') {
            window.vhallReportForProduct &&
              window.vhallReportForProduct.report(110101, {
                report_extra: { id: id }
              });
            window.vhallReportForProduct &&
              window.vhallReportForProduct.report(item.required === 'Y' ? 110104 : 110105, {
                report_extra: { id: id }
              });
            window.vhallReportForProduct &&
              window.vhallReportForProduct.report(110102, {
                report_extra: { id: id }
              });
            let nums = 0;
            item.detail.list.forEach(items => {
              if (items.isAdd) {
                nums++;
              }
            });
            if (nums > 0) {
              window.vhallReportForProduct &&
                window.vhallReportForProduct.report(110103, {
                  report_extra: { id: id, other: nums }
                });
            }
          }
          if (item.type === 'checkbox') {
            window.vhallReportForProduct &&
              window.vhallReportForProduct.report(110106, {
                report_extra: { id: id }
              });
            window.vhallReportForProduct &&
              window.vhallReportForProduct.report(item.required === 'Y' ? 110109 : 110110, {
                report_extra: { id: id }
              });
            window.vhallReportForProduct &&
              window.vhallReportForProduct.report(110107, {
                report_extra: { id: id }
              });
            let len = 0;
            item.detail.list.forEach(items => {
              if (items.isAdd) {
                len++;
              }
            });
            if (len > 0) {
              window.vhallReportForProduct &&
                window.vhallReportForProduct.report(110108, {
                  report_extra: { id: id, other: len }
                });
            }
          }
          // 问答
          if (item.type === 'text' && item.style === 'text') {
            window.vhallReportForProduct &&
              window.vhallReportForProduct.report(110111, {
                report_extra: { id: id }
              });
            window.vhallReportForProduct &&
              window.vhallReportForProduct.report(item.required === 'Y' ? 110112 : 110113, {
                report_extra: { id: id }
              });
          }
          if (item.type === 'remark') {
            window.vhallReportForProduct &&
              window.vhallReportForProduct.report(110114, {
                report_extra: { id: id }
              });
          }
        });
      },
      /**
       * @description 预览问卷
       */
      prevQuestion(id) {
        const selector = '#qn-server-box';
        this.showQuestionnaireTable = false;
        this.prevQuestionnaireId = id;
        window.vhallReportForProduct &&
          window.vhallReportForProduct.report(110063, {
            report_extra: { id: id }
          });
        this.questionnaireServer.renderQuestionnaire4Watch(selector, id);
      },
      handleCancel() {
        this.saveDialogVisible = false;
      },
      /**
       * @description 保存问卷
       */
      saveQuestionnaire() {
        this.saveDialogVisible = false;
        this.showQuestionnaireTable = true;
        if (this.hideItem) {
          // 隐藏共享对话框的情况下，"共享到表单"置为false
          this.shareQuestionnaire = false;
        }
        this.saving = true;
        if (this.alias) {
          this.questionnaireCreateInfo.alias = this.alias;
        }
        this.questionnaireServer
          .saveQuestionnaire(this.questionnaireCreateInfo, this.shareQuestionnaire)
          .then(res => {
            console.log('saveQuestionnaire', res);
            this.showTip = false;
            if (this.shareQuestionnaire) {
              // 确认同步才需要弹窗提示
              this.$message({
                message: res.code == 200 ? this.$t('host.k_585030') : this.$t('host.k_585031'),
                showClose: true,
                type: res.code == 200 ? 'success' : 'error',
                customClass: 'zdy-info-box'
              });
            }
            let questionCode = 110067;
            if (this.shareQuestionnaire) {
              questionCode = 110066;
            }
            window.vhallReportForProduct &&
              window.vhallReportForProduct.report(questionCode, {
                report_extra: { id: this.questionnaireCreateInfo.id }
              });
            if (res.code === 200) {
              // 数据有延迟
              const st = setTimeout(() => {
                this.queryQuestionnaireList(true);
                clearInterval(st);
              }, 1000);
            }
          })
          .finally(() => {
            this.saving = false;
          });
      },
      // 下拉框显示是, 中转当前选中变量
      dropDownVisibleChange(row) {
        console.log(row);
        this.selectedQuestionnarie = row;
      },
      // 更多列表的操作
      handleCommand(command) {
        if (!this.selectedQuestionnarie) return false;
        const id = this.selectedQuestionnarie.question_id;
        switch (command) {
          case 'data':
            this.goDetail(this.selectedQuestionnarie);
            break;
          case 'copy':
            this.copy(id);
            break;
          case 'del':
            this.delete(id);
            break;
        }
      },
      // 查看数据
      goDetail(questionnaireItem) {
        const watchInitData = this.$domainStore.state.roomBaseServer.watchInitData;
        const { webinar, interact } = watchInitData;
        if (this.$route.query.assistantType) {
          cl_openUrl(
            `https:${window.domainOfLive()}/v3/live/lookSingleQuestion/${webinar.id}?surveyId=${
              questionnaireItem.question_id
            }&subject=${questionnaireItem.title}&roomId=${interact.room_id}`
          );
          return;
        }
        window.open(
          `/v3/live/lookSingleQuestion/${webinar.id}?surveyId=${questionnaireItem.question_id}&subject=${questionnaireItem.title}&roomId=${interact.room_id}`
        );
      },
      // 复制
      copy(id) {
        const params = {
          surveyId: id
        };
        if (this.alias) {
          params.alias = this.alias;
        }
        this.questionnaireServer.copyQuestionnaire(params).then(res => {
          this.$message({
            type: res.code == 200 ? 'success' : 'error',
            message: res.msg
          });
          window.vhallReportForProduct &&
            window.vhallReportForProduct.report(110064, {
              report_extra: { id: id }
            });
          if (res.code == 200) {
            this.queryQuestionnaireList(true);
          }
        });
      },
      // 删除
      delete(id) {
        this.$vhConfirm(this.$t('host.k_585032'), this.$t('host.k_585020'), {
          confirmButtonText: this.$t('host.k_585033'),
          cancelButtonText: this.$t('host.k_585028'),
          lockScroll: false,
          roundButton: true
        }).then(() => {
          this.questionnaireServer.deleteQuestionnaire(id).then(res => {
            this.$message({
              type: res.code == 200 ? 'success' : 'error',
              message: res.msg
            });
            window.vhallReportForProduct &&
              window.vhallReportForProduct.report(110065, {
                report_extra: { id: id }
              });
            if (res.code == 200) {
              this.queryQuestionnaireList(true);
            }
          });
        });
      },
      // 推送问卷
      publish(questionnaireItem) {
        const watchInitData = this.$domainStore.state.roomBaseServer.watchInitData;
        const { webinar } = watchInitData;
        if (webinar.type !== 1) {
          return this.$message({
            type: 'warning',
            message: this.$t('host.k_585034')
          });
        }
        this.questionnaireServer.publishQuestionnaire(questionnaireItem.question_id).then(res => {
          if (res.code === 200) {
            console.log('res.msg:', res.msg);
            this.$message({
              type: 'success',
              message: this.$t(res.msg)
            });
            if (questionnaireItem.fromPrev) {
              this.initPage();
            } else {
              questionnaireItem.publish = 1;
            }
            window.VhallDataAgent.track('interact_publish_response', {
              button_type: 'questionnaire',
              button_biz_id: questionnaireItem.question_id,
              is_success: 1
            });
          } else {
            window.VhallDataAgent.track('interact_publish_response', {
              button_type: 'questionnaire',
              button_biz_id: questionnaireItem.question_id,
              is_success: 0,
              fail_reason: res.code
            });
          }
        });
      },
      // 滚动加载
      moreLoadData() {
        if (this.queryParams.pageNum >= this.totalPages) {
          return false;
        }
        this.queryParams.pageNum++;
        this.queryParams.pos = parseInt((this.queryParams.pageNum - 1) * this.queryParams.limit);
        this.queryQuestionnaireList();
      },
      // 问卷别名设置
      openSet() {
        this.dialogNameSet = true;
      },
      // 确定 or 取消的时候，数据还原。若为‘’，默认为问卷
      closeDialogNameSet() {
        this.dialogNameSet = false;
        this.alias = this.alias || this.$t('host.k_585001');
      },
      // 问卷别名设置样式预览
      showPreview() {
        this.dialogPreview = true;
      },
      // 问卷别名修改
      saveAlias() {
        this.questionnaireServer.setAlias(this.alias);
        this.dialogNameSet = false;
      }
    }
  };
</script>
<style lang="less">
  .questionnaire-live {
    .vh-line-question {
      color: #999;
    }
    .vh-dialog__wrapper {
      height: 100vh;
      overflow: hidden;
    }
    .preview_dialog {
      .img_base {
        padding: 4px;
        border-radius: 4px;
        background: #000;
        img {
          width: 100%;
        }
      }
      .vh-dialog__header {
        padding: 0;
      }
      .vh-dialog__body {
        height: 0px;
        padding: 0;
      }
      .vh-dialog__headerbtn {
        right: 0px;
        top: -30px;
        .vh-dialog__close {
          color: white;
        }
      }
      .img_size {
        width: 100%;
      }
    }
  }
  .questionnaire-dialog {
    margin-top: calc((100vh - 572px) / 2) !important; // 让弹窗保持居中
    .dialog-title {
      font-size: 20px;
    }
    .vh-dialog__body {
      // padding: 10px 20px 20px;
      padding: 0;
      height: 500px;
      overflow: auto;
      background-color: #f7f7f7;
    }
  }

  .vh-dropdown-menu {
    &.qn-more__dropdown {
      background-color: #fff;
      border: 1px solid #ebeef5;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

      .vh-dropdown-menu__item {
        &:focus,
        &:not(.is-disabled):hover {
          color: #606266;
          background-color: #ecf5ff;
        }
      }
      &.vh-popper[x-placement^='bottom'] {
        margin-top: 0;
      }
      &.vh-popper[x-placement^='bottom'] .popper__arrow {
        border-bottom-color: transparent;
      }
      &.vh-popper[x-placement^='bottom'] .popper__arrow::after {
        border-bottom-color: #fff;
      }
      &.vh-popper[x-placement^='top'] .popper__arrow {
        border-top-color: transparent;
      }
      &.vh-popper[x-placement^='top'] .popper__arrow::after {
        border-top-color: #fff;
      }
    }
  }
  .setname_tip {
    margin-top: 10px;
    color: #666;
  }
  .setname_button {
    text-align: right;
    margin-top: 10px;
    .hover_button_cancel:hover {
      color: var(--theme-color) !important;
      border-color: var(--theme-color) !important;
    }
  }
  .name_set_button {
    margin-right: 8px;
    color: var(--theme-color) !important;
  }
</style>
<style lang="less">
  .questionnarie.vh-dropdown-menu {
    background-color: #fff;
    .vh-dropdown-menu__item:hover {
      background-color: #f7f7f7;
      color: #606266;
    }
    .popper__arrow::after {
      border-bottom-color: #fff !important;
    }
  }
  .save-dialog {
    .vh-dialog__body {
      min-height: initial;
    }
  }
  .dialog-title {
    position: relative;
    .back-btn {
      position: absolute;
      top: 4px;
      left: -20px;
    }
  }

  .vhall-question-box {
    background: #fff;
    padding-bottom: 10px;
    .q-wrap .q-title {
      font-size: 26px;
    }
  }
  .vh-popper[x-placement^='bottom'] {
    margin-top: -10px;
  }
  /*复选选中效果重置*/
  .vh-checkbox__input.is-checked .vh-checkbox__inner,
  .vh-checkbox__input.is-indeterminate .vh-checkbox__inner {
    background-color: var(--theme-color) !important;
    border-color: var(--theme-color) !important;
  }
  .vh-checkbox__inner:hover {
    border-color: var(--theme-color) !important;
  }
  .vh-checkbox__input.is-focus .vh-checkbox__inner {
    border-color: #dcdfe6;
  }
  .vh-checkbox__input.is-checked.is-focus .vh-checkbox__inner {
    background-color: var(--theme-color) !important;
    border-color: var(--theme-color) !important;
  }

  /*单选选中效果重置*/
  .vh-radio__input.is-checked .vh-radio__inner {
    // background-color: var(--theme-color) !important;
    border-color: var(--theme-color) !important;
  }
  .vh-radio__inner:hover {
    border-color: var(--theme-color) !important;
  }
  /* 日期选择效果重置*/
  .vh-date-table td.today span {
    color: var(--theme-color);
  }
  .vh-date-table td.available:hover {
    color: var(--theme-color) !important;
  }
  .vh-date-table td.current:not(.disabled) span {
    color: #fff;
    background-color: var(--theme-color) !important;
  }

  .vh-dropdown-menu {
    background-color: #fff;
  }
  .vh-dropdown-menu__item:not(.is-disabled):hover {
    background-color: #f7f7f7;
    color: #1a1a1a;
  }
  .qn-server-warp {
    padding: 10px 20px 20px;
    background: #f7f7f7;
    &.preview {
      padding: 0 0 60px;
      background: #fff;
      .q-btns {
        display: none; // 隐藏提交问卷
      }
    }
  }

  .publish-btn {
    display: block;
    width: 160px;
    border: none;
    margin: 40px auto 0 auto;
    background-color: var(--theme-color) !important;
    color: #fff !important;
  }

  .async__body {
    background: #fff;
    padding: 10px 32px 24px;
    p {
      font-size: 14px;
    }
    .async__ctx {
      .vh-checkbox {
        padding: 8px 0 !important;
      }
      .vh-checkbox__label {
        color: #1a1a1a;
      }
      .vh-checkbox__input.is-checked .vh-checkbox__inner {
        background-color: var(--theme-color) !important;
        border-color: var(--theme-color) !important;
      }
      .vh-checkbox__input.is-focus .vh-checkbox__inner {
        border-color: var(--theme-color) !important;
      }
      .vh-checkbox__inner:hover {
        border-color: var(--theme-color) !important;
      }
    }
    .async__footer {
      padding-top: 16px;
      float: right;
    }
  }

  .return-btn {
    position: absolute;
    top: 25px;
    left: 12px;
    font-size: 14px;
    color: #666;
    cursor: pointer;
    i {
      font-size: 13px;
    }
  }
  .qa-create-out {
    height: 500px;
    background: #fff;
    overflow: auto;
    position: relative;

    .black {
      font-size: 12px;
      height: 30px;
      line-height: 28px;
      width: 80px;
      border: solid 1px #999999;
      border-radius: 2px;
      background-color: #fff;
      color: #666;
      outline: none;
      cursor: pointer;
      display: inline-block;
      position: absolute;
      top: 10px;
      right: 20px;
      text-decoration: none;
      text-align: center;
      // float: right;
      z-index: 100;
      &:hover {
        color: #fff;
        border: 1px solid var(--theme-color) !important;
        background-color: var(--theme-color) !important;
      }
    }
  }

  .question__content {
    height: 100%;
    background: #fff;
  }

  .vhall-question__content {
    box-sizing: border-box;
    height: 100%;
    padding: 0 32px 16px;
    overflow: hidden;
    background: #fff;
    position: relative;
    &-search {
      .create {
        // height: 36px;
        // background: var(--theme-color) !important;
        // color: #fff;
        // font-size: 14px;
        // text-align: center;
      }
      .vh-input__inner {
        height: 36px;
        border-radius: 20px !important;
      }
      .vh-input__icon {
        line-height: 36px;
      }
    }
    &.assistantStyle {
      height: 420px;
    }
    &-title {
      height: 42px;
      line-height: 42px;
      background: #fff;
    }
    ::-webkit-scrollbar {
      width: 6px; // 横向滚动条
      height: 6px; // 纵向滚动条 必写
    }
    // 滚动条的滑块
    ::-webkit-scrollbar-thumb {
      border-radius: 5px;
      transition: all 0.3s;
      cursor: pointer;
      display: none;
      background-color: #e0e0e0;
    }
    ::-webkit-scrollbar-track {
      background-color: transparent;
    }
    &:hover {
      ::-webkit-scrollbar-thumb {
        display: block;
      }
    }
    .popbody {
      // height: 100%;
      padding-top: 24px;
      .vhall-question__content-list {
        max-height: 420px;
        &.assistantStyle {
          height: 370px;
        }
        overflow-y: auto;
        li {
          display: flex;
          line-height: 56px;
          height: 56px;
          font-size: 14px;
          color: #1a1a1a;
        }
        .data-list {
          height: 360px;
          overflow: auto;
        }
      }
      .creatBtn {
        height: 50px;
        line-height: 50px;
      }
      .vhall-question__content-list__colmun-title {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .fontColor {
        color: #666;
      }
    }
    &-list {
      font-size: 12px;
      color: #666;
      li {
        height: 45px;
        line-height: 56px;
        padding-left: 12px;
        padding-right: 5px;
        // &:nth-child(odd) {
        //   background: #f8f8f8;
        // }
        span {
          display: inline-block;
        }
        &:hover {
          background: #f7f7f7;
          .item {
            color: var(--theme-color) !important;
          }
          .colorItem {
            color: var(--theme-color) !important;
          }
        }
      }
      &__colmun-title {
        width: 245px;
        padding-right: 20px;
      }

      &__colmun-time {
        width: 80px;
      }

      &__colmun-source {
        width: 160px;
      }

      &__colmun-action {
        width: 210px;
        white-space: nowrap;

        a {
          display: inline-block;
          width: 36px;
          height: 20px;
          vertical-align: middle;
        }
        span {
          font-size: 14px;
          cursor: pointer;
          color: #1a1a1a;
        }
        .item {
          padding: 0 6px;
        }
        .vh-dropdown {
          // color: #1a1a1a !important;
        }
        .vh-dropdown-menu {
          background-color: #fff;
          &:hover {
            background-color: #f7f7f7;
          }
        }
        &--send {
          background: url(./images/fq.png) no-repeat;
          background-size: 100%;
          &:hover {
            background: url(./images/fq-hover.png) no-repeat;
            background-size: 100%;
          }
        }
        &--preview {
          background: url(./images/yl.png) no-repeat;
          background-size: 100%;
          &:hover {
            background: url(./images/yl-hover.png) no-repeat;
            background-size: 100%;
          }
        }
        &--editor {
          background: url(./images/xg.png) no-repeat;
          background-size: 100%;
          &:hover {
            background: url(./images/xg-hover.png) no-repeat;
            background-size: 100%;
          }
        }
        &--detail {
          background: url(./images/xq.png) no-repeat;
          background-size: 100%;
          &:hover {
            background: url(./images/xq-hover.png) no-repeat;
            background-size: 100%;
          }
        }
      }
    }

    &-list__title {
      height: 56px;
      line-height: 56px;
      background: #f7f7f7;
    }

    .vhall-question-btn {
      background-color: #fff;
      border: 1px solid var(--theme-color) !important;
      color: var(--theme-color) !important;
      font-size: 12px;
      width: 100px;
      height: 30px;
      box-sizing: border-box;
      border-radius: 2px;
      padding: 0;
      line-height: 26px;
      display: inline-block;
      cursor: pointer;
      &:hover {
        background: var(--theme-color) !important;
        color: #fff;
      }
    }
    .show-no-msg {
      text-align: center;
      .no-img {
        display: inline-block;
        width: 130px;
        height: 130px;
        margin-top: 50px;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: scale-down;
      }
      .no-msg {
        color: #666;
        font-size: 14px;
        line-height: 20px;
      }
      .list-create {
        display: inline-block;
        min-width: 100px;
        height: 36px;
        line-height: 36px;
        border-radius: 20px;
        padding: 0 11px;
        background: var(--theme-color) !important;
        color: #fff;
        font-size: 14px;
        text-align: center;
        margin-top: 32px;
        cursor: pointer;
      }
    }
    .text-center {
      margin-top: 60px;
    }
  }
  #qs-create-box {
    .goback-btn {
      display: none;
    }
    .question-edit-wrap {
      padding: 10px 20px 20px;
      background: #f7f7f7;
      .edit-content-main {
        padding-bottom: 30px;
      }
      .question-bottom {
        margin-bottom: 30px;
        & > .vh-button {
          line-height: 0px !important;
        }
      }
    }
  }
  .q-wrap {
    padding-bottom: 30px;
  }
  .cef-q-wrap {
    .q-wrap {
      overflow-y: hidden;
    }
  }
</style>
<style lang="less">
  .questionnaire-live {
    .question-box-dialog {
      .avatar-uploader {
        height: 120px !important;
        .img-logo {
          height: 120px !important;
        }
      }
    }
  }
</style>
